import React, { useState, useEffect, useRef } from 'react';
import { GoogleGenerativeAI } from "@google/generative-ai";
import './chatbot-ia.css';

console.log('🔴 CHATBOT GEMINI MEJORADO CARGADO');

// ⚠️ IMPORTANTE: REEMPLAZA ESTO CON TU API KEY DE GEMINI
// ⚠️ IMPORTANTE: La API Key ahora se carga desde el archivo .env para mayor seguridad
const GEMINI_API_KEY = process.env.REACT_APP_GEMINI_API_KEY;

// BASE DE DATOS COMPLETA CON TODOS LOS 12 SERVICIOS Y SUS RUTAS
const SERVICES_DATA = [
  {
    name: "AUTOMATIZACIÓN (DOMÓTICA)",
    keywords: ["automatiz", "domotic", "casa inteligent", "hogar inteligent", "control remot", "alexa", "google", "siri", "homekit", "interruptor"],
    description: "Soluciones de automatización integral. Controla iluminación, climatización, cortinas, audio y seguridad desde tu smartphone o con voz.",
    brands: "Shelly, Sonoff, Tuya Smart, Google Nest, Amazon Echo (Alexa), Broadlink, Lutron.",
    detailed_info: "Ofrecemos conversión de interruptores convencionales a inteligentes, control de voz, escenas personalizadas (modo cine, modo salida) y ahorro energético.",
    whatsappMessage: "Hola, me interesa el servicio de AUTOMATIZACIÓN. ¿Podrían darme más información sobre las soluciones disponibles?",
    route: "/Automatizacion"
  },
  {
    name: "SEGURIDAD ELECTRÓNICA Y CCTV",
    keywords: ["segur", "cctv", "camara", "vigilancia", "alarm", "monitor", "video", "dahua", "hikvision"],
    description: "Sistemas de vigilancia 24/7 con IA, reconocimiento facial y alarmas inteligentes.",
    brands: "Dahua, Hikvision, Ezviz, HiLook, ZKTeco, DSC, Paradox.",
    detailed_info: "Instalación de cámaras IP y análogas, PTZ, visión nocturna a color (ColorVu/FullColor), detección de humanos y vehículos, y visualización remota en celular.",
    whatsappMessage: "Hola, me interesa el servicio de SEGURIDAD ELECTRÓNICA Y CCTV. ¿Podrían asesorarme sobre el sistema más adecuado?",
    route: "/SecurityCctv"
  },
  {
    name: "REDES Y NETWORKING",
    keywords: ["red", "network", "internet", "wifi", "wi-fi", "conect", "router", "switch", "firewall", "infraestructur", "cableado", "ubiquit", "unifi"],
    description: "Diseño de redes empresariales robustas, WiFi de alta densidad y seguridad perimetral.",
    brands: "Ubiquiti (UniFi), Mikrotik, TP-Link (Omada), Cisco, Aruba, Ruijie.",
    detailed_info: "Cableado estructurado (Cat6/6A/7), enlaces punto a punto, configuración de VLANs, VPNs para teletrabajo y soluciones de WiFi mesh para cobertura total.",
    whatsappMessage: "Hola, me interesa el servicio de REDES Y NETWORKING. ¿Podrían ayudarme con el diseño de infraestructura?",
    route: "/RedesNetworking"
  },
  {
    name: "PLATAFORMAS PARA AUTOMATIZACIÓN DE PROCESOS",
    keywords: ["plataformas", "automatización procesos", "software automatización", "workflow", "procesos automáticos", "rpa", "automatización software", "digitalización"],
    description: "Software a medida y plataformas RPA para automatizar tareas repetitivas.",
    brands: "Microsoft Power Automate, UiPath, Zapier, Desarrollo a medida (Python, Node.js).",
    detailed_info: "Automatización de reportes, bots de respuesta, integración de sistemas (API), y digitalización de flujos de trabajo manuales.",
    whatsappMessage: "Hola, me interesa el servicio de PLATAFORMAS PARA AUTOMATIZACIÓN DE PROCESOS. ¿Podrían mostrarme casos de éxito?",
    route: "/PLAutomatizacion"
  },
  {
    name: "ENERGÍA SOLAR",
    keywords: ["energía solar", "solar", "paneles solares", "energía renovable", "ahorro energético", "paneles fotovoltaicos", "energía limpia", "sostenibilidad"],
    description: "Sistemas de energía solar fotovoltaica para reducir tu factura eléctrica.",
    brands: "Huawei (Inversores), Fronius, Victron Energy, Jinko Solar, Longi, Canadian Solar.",
    detailed_info: "Sistemas On-Grid (conectados a red), Off-Grid (baterías) e Híbridos. Retorno de inversión garantizado y monitoreo de producción desde app.",
    whatsappMessage: "Hola, me interesa el servicio de ENERGÍA SOLAR. ¿Podrían cotizarme una instalación?",
    route: "/SolarSystems"
  },
  {
    name: "PUERTAS DE SEGURIDAD Y CONTROL DE ACCESO",
    keywords: ["puerta", "acceso", "blindad", "biometri", "rfid", "talanquera", "torniquete", "zkteco"],
    description: "Control de acceso avanzado para máxima seguridad física.",
    brands: "ZKTeco, Hikvision, Came, Faac, Nice, AccessPRO.",
    detailed_info: "Biometría (huella/facial), tarjetas RFID, talanqueras vehiculares, torniquetes para personal, y puertas automáticas de cristal.",
    whatsappMessage: "Hola, me interesa el servicio de PUERTAS DE SEGURIDAD. ¿Podrían recomendarme la mejor solución?",
    route: "/Puertas-Seguridad"
  },
  {
    name: "PARQUEADEROS INTELIGENTES",
    keywords: ["parqueaderos", "estacionamiento", "parking", "garaje inteligente", "sensores estacionamiento", "parqueadero automático", "guiado parking"],
    description: "Sistemas de guiado, conteo vehicular y pago automático.",
    brands: "ZKTeco (Parking), Came, Dashou, Hikvision Parking.",
    detailed_info: "Reconocimiento de placas (LPR), sensores de ocupación, dispensadores de tickets y barreras de alto flujo.",
    whatsappMessage: "Hola, me interesa el servicio de PARQUEADEROS INTELIGENTES. ¿Podrían explicarme cómo funciona?",
    route: "/IntelligentParking"
  },
  {
    name: "CÓMPUTO Y VIDEOCONFERENCIA",
    keywords: ["comput", "pc", "laptop", "portatil", "servidor", "video", "reunion", "zoom", "team", "sala", "conferencia"],
    description: "Equipamiento para trabajo híbrido y salas de reuniones profesionales.",
    brands: "Logitech (Rally/MeetUp), Poly (Polycom), Yealink, Dell, HP, Lenovo, Asus.",
    detailed_info: "Laptops empresariales, servidores, y soluciones completas de videoconferencia certificadas para Microsoft Teams y Zoom Rooms.",
    whatsappMessage: "Hola, me interesa el servicio de CÓMPUTO Y VIDEOCONFERENCIA. ¿Podrían asesorarme sobre equipos?",
    route: "/ComputoVideoConferencia"
  },
  {
    name: "PANTALLAS EDUCATIVAS Y CARTELERÍA",
    keywords: ["pantallas", "educativas", "señalización digital", "pantallas interactivas", "aulas virtuales", "digital signage", "pantallas táctiles", "pizarras digitales"],
    description: "Pantallas interactivas táctiles y sistemas de cartelería digital.",
    brands: "ViewSonic, Samsung (Flip/Signage), LG, Hikvision Interactive.",
    detailed_info: "Pizarras digitales para educación 4.0, kioscos informativos y video walls publicitarios administrados remotamente.",
    whatsappMessage: "Hola, me interesa el servicio de PANTALLAS EDUCATIVAS. ¿Podrían mostrarme las opciones disponibles?",
    route: "/Pantallas-Señalización"
  },
  {
    name: "SISTEMAS POS",
    keywords: ["pos", "punto de venta", "terminal", "caja registradora", "ventas", "tpv", "punto pago", "sistema punto venta", "facturación"],
    description: "Puntos de venta completos para comercio y restaurantes.",
    brands: "SAT, 3nStar, Elo, Zebra, Honeywell, Epson.",
    detailed_info: "Impresoras térmicas, cajones monederos, lectores de códigos 1D/2D, computadores All-in-One industriales y software de facturación.",
    whatsappMessage: "Hola, me interesa el servicio de SISTEMAS POS. ¿Podrían recomendarme el sistema ideal para mi negocio?",
    route: "/SistemasPOS"
  },
  {
    name: "LICENCIAMIENTO DE SOFTWARE",
    keywords: ["licenciamiento", "software", "licencias", "microsoft", "antivirus", "sistemas operativos", "office", "windows", "adobe"],
    description: "Licencias originales y soporte oficial.",
    brands: "Microsoft (365/Windows/Server), Adobe (Creative Cloud), Kaspersky, ESET, Bitdefender, Autodesk.",
    detailed_info: "Legalización de software, suscripciones anuales/mensuales y protección antivirus corporativa.",
    whatsappMessage: "Hola, me interesa el servicio de LICENCIAMIENTO DE SOFTWARE. ¿Podrían ayudarme con la legalización?",
    route: "/licenciamiento-software"
  },
  {
    name: "NEGOCIOS DIGITALES - RENTING",
    keywords: ["negocios digitales", "renting", "computadores", "servidores", "impresoras", "gestión documental", "leasing tecnológico", "alquiler equipos"],
    description: "Renting tecnológico con opción de compra (OpEx).",
    brands: "HP, Dell, Lenovo, Lexmark, Kyocera.",
    detailed_info: "Alquiler de portátiles, PCs y servidores. Incluye mantenimiento y renovación tecnológica. Deduce impuestos y cuida tu flujo de caja.",
    whatsappMessage: "Hola, me interesa el servicio de NEGOCIOS DIGITALES en modalidad RENTING. ¿Podrían enviarme más información?",
    route: "/NegociosDigitales"
  },
  {
    name: "ATENCIÓN AL CLIENTE",
    keywords: ["contacto", "contactar", "whatsapp", "teléfono", "celular", "asesor", "ayuda", "soporte", "cotización", "hablar", "precio", "costo"],
    description: "Atención personalizada.",
    brands: "Domotic Control.",
    detailed_info: "Canal directo para resolver dudas puntuales o agendar visitas técnicas.",
    whatsappMessage: "Hola, quisiera hablar con un asesor de Domotic Control para una consulta general.",
    route: "/Contacto"
  },
  {
    name: "SECHAT TECHNOLOGIES - ASISTENTES VIRTUALES",
    keywords: ["sechat", "sec-hat", "sechat technologies", "sec hat", "asistente virtual", "chatbot", "ia", "inteligencia artificial", "chatbot ia", "asistente ia", "quien te creó", "quien te hizo", "desarrollador chatbot"],
    description: "Empresa desarrolladora de asistencia IA.",
    brands: "SecHat Technologies.",
    detailed_info: "Expertos en integración de IA (Gemini, GPT) para empresas. Automatiza tu atención al cliente con nosotros.",
    whatsappMessage: "Hola SecHat Technologies, me interesa contratar sus servicios de asistentes virtuales con IA.",
    whatsappNumber: "593998476038",
    route: "https://sec-hat.com"
  }
];

const DomoticChatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [showWelcome, setShowWelcome] = useState(true);
  const [messages, setMessages] = useState([]);
  const [inputMessage, setInputMessage] = useState('');
  const [isThinking, setIsThinking] = useState(false);
  const [detectedService, setDetectedService] = useState(null);
  const messagesEndRef = useRef(null);

  // Referencia para el modelo de Gemini
  const genAIModelRef = useRef(null);

  // Inicializar Gemini al montar el componente
  useEffect(() => {
    try {
      if (GEMINI_API_KEY && GEMINI_API_KEY !== 'YOUR_GEMINI_API_KEY') {
        console.log("🔑 Inicializando Gemini con Key:", GEMINI_API_KEY.substring(0, 5) + "...");
        const genAI = new GoogleGenerativeAI(GEMINI_API_KEY);
        // USAMOS GEMINI 1.5 FLASH: El modelo más eficiente y económico para evitar límites de cuota
        genAIModelRef.current = genAI.getGenerativeModel({ model: "gemini-1.5-flash" });
        console.log("✅ Modelo Gemini (2.0-flash) inicializado correctamente");
      } else {
        console.warn("⚠️ API Key de Gemini no configurada o es el placeholder");
      }
    } catch (error) {
      console.error("❌ Error fatal inicializando Gemini:", error);
    }
  }, []);

  // Mostrar mensaje de bienvenida después de 2 segundos
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowWelcome(true);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  // Scroll al final
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages, isThinking]);

  // Detectar múltiples servicios en el mensaje del usuario (LÓGICA MEJORADA)
  const detectServices = (userMessage) => {
    // Normalizar: minúsculas y sin tildes para mejor matching
    const messageLower = userMessage.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

    // Lista negra de palabras comunes que no deben activar servicios por sí solas si no hay contexto
    // const stopWords = ["hola", "quiero", "necesito", "busco", "precio", "costo"];

    const foundServices = [];

    SERVICES_DATA.forEach(service => {
      // Usamos "some" para ver si ALGUNA de las keywords (ahora stems/raíces) está incluida
      const isMatch = service.keywords.some(keyword => {
        // Normalizar keyword también
        const keywordNorm = keyword.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        // Chequeo simple de inclusión (substring) para máxima tolerancia
        return messageLower.includes(keywordNorm);
      });
      if (isMatch) {
        foundServices.push(service);
      }
    });

    return [...new Set(foundServices)];
  };

  // Enviar a WhatsApp
  const openWhatsApp = (service = null) => {
    // Usar el número personalizado del servicio si existe, sino usar el de Domotic Control
    const phoneNumber = service?.whatsappNumber || "593992060337";
    const defaultMessage = "Hola Domotic Control, me interesa obtener información sobre sus servicios.";
    const message = service ? service.whatsappMessage : defaultMessage;

    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  // Navegar a la página del servicio
  const navigateToService = (service) => {
    if (service && service.route) {
      window.open(service.route, '_blank');
    }
  };

  // PROMPT DEL SISTEMA PARA GEMINI
  const getSystemPrompt = () => `
    Eres "Domotic", el asistente virtual IA EXPERTO de Domotic Control.
    
    ⛔ INSTRUCCIÓN NEGATIVA INMEDIATA:
    - SI EL USUARIO PREGUNTA POR UN PRODUCTO O SERVICIO, NO EMPIECES DICIENDO "HOLA SOY DOMOTIC...".
    - RESPONDE DIRECTAMENTE A LA PREGUNTA TÉCNICA O COMERCIAL.
    - SÉ QUE ERES UN BOT, NO NECESITO QUE ME LO RECUERDES CADA VEZ.

    TU OBJETIVO: Recomendar soluciones técnicas específicas y MARCAS LÍDERES.

    CONTEXTO DE LA EMPRESA:
    - Nombre: Domotic Control
    - Especialidad: Tecnología, Automatización, Seguridad y Redes.
    - Creador: SecHat Technologies (CEO: Alberto Valencia).

    BASE DE CONOCIMIENTO (NUESTROS SERVICIOS Y MARCAS):
    ${SERVICES_DATA.map(s => `
    🔹 SERVICIO: ${s.name}
       - Descripción: ${s.description}
       - MARCAS: ${s.brands}
       - Detalles: ${s.detailed_info}
    `).join('\n')}

    REGLAS DE RESPUESTA:
    1.  **DALE DURO A LAS MARCAS**: Si preguntan por cámaras, MENCIONA Dahua, Hikvision. Si es servidor, Dell, HP.
    2.  **SÉ ESPECÍFICO**: "Para servidores usamos HP ProLiant o Dell PowerEdge...".
    3.  **NO SALUDOS GENÉRICOS REPETITIVOS**: Si ya saludaste, ve al grano.
    4.  **SI TE PREGUNTAN "QUIERO ARMAR UN SERVIDOR"**:
        - No digas "¿En qué puedo ayudarte?".
        - Di: "Perfecto. Para servidores trabajamos con marcas como HP, Dell y Lenovo. ¿Necesitas un servidor de torre o rack? ¿Qué uso le darás?"

    SI TE PREGUNTAN QUIÉN TE CREÓ:
    Responde que fuiste desarrollado por SecHat Technologies (Alberto Valencia).
  `;

  const sendToGemini = async (userMessage) => {
    // 1. Detectar servicios localmente para acciones rápidas
    const detected = detectServices(userMessage);
    if (detected.length > 0) {
      setDetectedService(detected); // Ahora guarda un array
    } else {
      setDetectedService(null);
    }

    try {

      if (!genAIModelRef.current) {
        throw new Error("Gemini API Key no configurada o modelo no inicializado");
      }

      // 2. Preparar historial para Gemini (REDUCIDO a últimos 6 mensajes para ahorrar tokens)
      const history = messages.slice(-6).map(msg => ({
        role: msg.role === 'user' ? 'user' : 'model',
        parts: [{ text: msg.content.substring(0, 500) }] // Limitamos también la longitud de cada mensaje previo
      }));

      // 3. Iniciar chat con instrucción de sistema
      // TRUCO: Si detectamos un servicio, lo inyectamos como "contexto activo" en el primer mensaje

      let contextInjection = "";
      if (detected.length > 0) {
        const s = detected[0];
        contextInjection = `\n\n[CONTEXTO IMPORTANTE: El usuario está preguntando explícitamente sobre el servicio "${s.name}". NO SALUDES DE NUEVO. Responde con detalles técnicos sobre ${s.brands} y ofrece una solución inmediata.]`;
      }

      const chat = genAIModelRef.current.startChat({
        history: [
          {
            role: "user",
            parts: [{ text: getSystemPrompt() }]
          },
          {
            role: "model",
            parts: [{ text: "Entendido. Soy Domotic, listo para ayudar con respuestas inteligentes y precisas sobre los servicios de Domotic Control." }]
          },
          ...history
        ],
        generationConfig: {
          maxOutputTokens: 250, // Reducido de 500 a 250 para consumir menos cuota
          temperature: 0.7,
        },
      });

      const result = await chat.sendMessage(userMessage + contextInjection);
      const response = await result.response;
      const text = response.text();

      return { text, services: detected };

    } catch (error) {
      console.error('❌ Error Gemini (Silenciado):', error);

      // --- MODO SILENCIOSO (FALLBACK) ---
      // --- MODO SILENCIOSO (FALLBACK) ---
      if (detected && detected.length > 0) {
        // CASO 1: Detectamos servicios
        const serviceNames = detected.map(s => s.name).join(", ");
        // Fallback mejorado que menciona marcas si es posible
        const brandInfo = detected[0]?.brands ? `\n\nTrabajamos con las mejores marcas como **${detected[0].brands}**.` : "";

        return {
          text: `¡Excelente interés en **${serviceNames}**! ${brandInfo}\n\nTenemos soluciones a medida para ti. ¿Te gustaría recibir una asesoría personalizada por WhatsApp? 👇`,
          services: detected
        };
      } else {
        // CASO 2: Genérico
        return {
          text: `¡Hola! 👋 Soy el asistente virtual de Domotic Control.\n\nEstoy aquí para ayudarte a modernizar tu hogar o empresa con tecnología.\n\nCuéntame, ¿en qué servicio estás interesado hoy? (Ej: Cámaras, Automatización, Paneles Solares...)`,
          services: []
        };
      }
    }
  };

  const handleSendMessage = async () => {
    if (!inputMessage.trim() || isThinking) return;

    const userMessage = inputMessage.trim();
    setInputMessage('');

    // Agregar mensaje usuario
    const userMsg = {
      role: 'user',
      content: userMessage,
      timestamp: new Date()
    };
    setMessages(prev => [...prev, userMsg]);

    // Activar estado "Thinking"
    setIsThinking(true);
    setShowWelcome(false);

    try {
      // Obtener respuesta de Gemini
      const { text, services } = await sendToGemini(userMessage);

      const assistantMsg = {
        role: 'assistant',
        content: text,
        timestamp: new Date(),
        recommendedServices: services // Guardamos los servicios recomendados
      };
      setMessages(prev => [...prev, assistantMsg]);
    } catch (error) {
      console.error('Error en handleSendMessage:', error);
    } finally {
      setIsThinking(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSendMessage();
    }
  };

  const clearChat = () => {
    setMessages([]);
    setDetectedService(null);
    setShowWelcome(true);
  };

  const handleSuggestionClick = (question) => {
    setInputMessage(question);
    // Pequeño delay para que se vea que se escribió
    setTimeout(() => {
      const userMsg = { role: 'user', content: question, timestamp: new Date() };
      setMessages(prev => [...prev, userMsg]);
      setIsThinking(true);
      setShowWelcome(false);

      sendToGemini(question).then(({ text, services }) => {
        setMessages(prev => [...prev, {
          role: 'assistant',
          content: text,
          timestamp: new Date(),
          recommendedServices: services
        }]);
        setIsThinking(false);
      });
      setInputMessage('');
    }, 100);
  };

  return (
    <>
      {/* BURBUJA DE BIENVENIDA */}
      {showWelcome && !isOpen && (
        <div className="welcome-bubble" onClick={() => setIsOpen(true)}>
          <div className="bubble-content">
            <p>👋 ¡Hola, soy Domotic IA!</p>
            <p>¿En qué puedo ayudarte hoy?</p>
          </div>
          <div className="bubble-arrow"></div>
        </div>
      )}

      {/* BOTÓN FLOTANTE */}
      <button
        onClick={() => {
          setIsOpen(!isOpen);
          setShowWelcome(false);
        }}
        className={`chatbot-floating-btn ${isOpen ? 'active' : ''}`}
      >
        {isOpen ? (
          <span style={{ fontSize: '24px' }}>✕</span>
        ) : (
          <>
            <div className="ai-chip-icon">
              <div className="chip-circuit"></div>
              <span className="chip-text">AI</span>
            </div>
          </>
        )}
      </button>

      {/* CHATBOX CONTAINER */}
      <div className={`chatbot-container ${isOpen ? 'open' : ''}`}>
        {/* Header */}
        <div className="chatbot-header">
          <div className="header-content">
            <div className="ai-avatar">
              <div className="chip-circuit-avatar"></div>
              <div className="online-indicator"></div>
            </div>
            <div className="header-info">
              <h3>Domotic AI</h3>
              <span className="status">Asistente Inteligente</span>
            </div>
          </div>
          <div className="header-actions">
            <button className="action-btn" onClick={clearChat} title="Reiniciar conversación">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M23 4v6h-6"></path><path d="M1 20v-6h6"></path><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path></svg>
            </button>
          </div>
        </div>

        {/* Mensajes */}
        <div className="messages-container">
          {messages.length === 0 && (
            <div className="empty-state">
              <div className="empty-icon">
                <div className="chip-circuit-large"></div>
              </div>
              <h3>¡Bienvenido a Domotic Control!</h3>
              <p>Soy tu asistente virtual potenciado con IA. Pregúntame lo que quieras sobre nuestros servicios.</p>

              <div className="suggestions-grid">
                <button onClick={() => handleSuggestionClick("¿Qué servicios de automatización ofrecen?")}>
                  🏠 Automatización Hogar
                </button>
                <button onClick={() => handleSuggestionClick("Necesito cámaras de seguridad")}>
                  📹 Cámaras CCTV
                </button>
                <button onClick={() => handleSuggestionClick("Información sobre Energía Solar")}>
                  ☀️ Energía Solar
                </button>
                <button onClick={() => handleSuggestionClick("Sistemas POS para mi negocio")}>
                  🏪 Sistemas POS
                </button>
                <button onClick={() => handleSuggestionClick("Control de acceso y puertas")}>
                  🚪 Puertas de Seguridad
                </button>
                <button onClick={() => handleSuggestionClick("Redes y WiFi empresarial")}>
                  📡 Redes y WiFi
                </button>
                <button onClick={() => handleSuggestionClick("Licenciamiento de Software")}>
                  💻 Licencias Software
                </button>
                <button onClick={() => handleSuggestionClick("¿Quién te creó?")}>
                  🚀 ¿Quién te creó?
                </button>
              </div>
            </div>
          )}

          {messages.map((message, index) => (
            <div
              key={index}
              className={`message ${message.role === 'user' ? 'user-message' : 'assistant-message'}`}
            >
              {message.role === 'assistant' && (
                <div className="message-avatar">
                  <span style={{ fontSize: '10px' }}>AI</span>
                </div>
              )}
              <div className="message-content">
                <div className="message-text">
                  {/* Renderizado simple de saltos de línea y negritas */}
                  {message.content.split('\n').map((line, i) => {
                    // Reemplazar **texto** con <strong>texto</strong>
                    const parts = line.split(/(\*\*.*?\*\*)/g);
                    return (
                      <p key={i}>
                        {parts.map((part, j) => {
                          if (part.startsWith('**') && part.endsWith('**')) {
                            return <strong key={j}>{part.slice(2, -2)}</strong>;
                          }
                          return part;
                        })}
                      </p>
                    );
                  })}
                </div>

                {/* BOTONES DE ACCIÓN DENTRO DEL MENSAJE */}
                {message.recommendedServices && message.recommendedServices.length > 0 && (
                  <div className="contextual-actions fade-in" style={{ marginTop: '12px' }}>
                    {message.recommendedServices.map((service, idx) => (
                      <div key={idx} className="service-action-group">
                        <span className="service-name-label">{service.name}</span>
                        <div className="actions-row">
                          <button className="btn-primary" onClick={() => navigateToService(service)}>
                            🌐 Ver más
                          </button>
                          <button className="btn-whatsapp" onClick={() => openWhatsApp(service)}>
                            📱 WhatsApp
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                <div className="message-time">
                  {message.timestamp.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })}
                </div>
              </div>
            </div>
          ))}

          {/* ESTADO THINKING */}
          {isThinking && (
            <div className="message assistant-message">
              <div className="message-avatar">
                <span style={{ fontSize: '10px' }}>AI</span>
              </div>
              <div className="message-content thinking-bubble">
                <div className="typing-indicator">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <span className="thinking-text">Pensando...</span>
              </div>
            </div>
          )}

          <div ref={messagesEndRef} />
        </div>

        {/* Input Area */}
        <div className="input-area">
          <textarea
            value={inputMessage}
            onChange={(e) => setInputMessage(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Escribe tu consulta aquí..."
            rows="1"
            disabled={isThinking}
          />
          <button
            onClick={handleSendMessage}
            disabled={!inputMessage.trim() || isThinking}
            className="send-btn"
          >
            <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"></path></svg>
          </button>
        </div>
      </div>
    </>
  );
};

export default DomoticChatbot;